module.exports = __webpack_public_path__ + "assets/AirbnbCereal-ExtraBold.1f171c6cdc89631ff6f998f182986c0a.woff2";